import React from 'react';
import { ListGroup } from 'react-bootstrap';

const match = ({ alertClicked, address, longitude, latitude }) => {


    const MatchStyles = {
        height: "10%",
        zIndex: "1000"
    }

    const ImgStyles = {
        float: "right",
        //display: "inline",
        //marginTop:"-11%",
        height: "4%",
        width: "4%"
    }

    const ImgStylesLoc = {
        float: "left",
        //display: "inline",
        //marginTop:"-11%",
        height: "4%",
        width: "4%"
    }

    const latLon = [
        {longitude: `${longitude}`},
        {latitude: `${latitude}`}
    ]
    
return (
    <ListGroup.Item
        style={MatchStyles} 
        className="Matches"
        action 
        value={`[${latitude}, ${longitude}]`}
        // function expressions could cause this to rerender unnecessarily.
        onClick={(address) => alertClicked(address)}> 
          {`${address.toLowerCase()}`}
          <img 
            style={ImgStyles}
            src="https://img.icons8.com/ios-glyphs/32/000000/up-left-arrow.png" alt = "arrow">
          </img>
          <img
            style={ImgStylesLoc} 
            src="https://img.icons8.com/material/24/000000/worldwide-location--v1.png" alt= "userloc"> 
          </img>
    </ListGroup.Item>
)
}

export default match;
